import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	padding: 20px 30px 30px 0;
`;

const StyledSearchContainer = styled.div`
	margin: 20px 0 30px;
`;

const StyledListContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export { StyledContainer, StyledListContainer, StyledSearchContainer };
